import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { fetchWorkflowById, getLoadedWorkflow } from '../slices/workflow';

const useWorkflowData = () => {
  const dispatch = useDispatch();
  const { workflowId } = useParams();
  // Empty until this link's own workflow is loaded.
  const workflowData = useSelector(({ workflow }) =>
    getLoadedWorkflow(workflow, workflowId)
  );

  useEffect(() => {
    if (isEmpty(workflowData)) {
      dispatch(fetchWorkflowById(workflowId));
    }
  }, [dispatch, workflowId, workflowData]);
};

export default useWorkflowData;
